// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require('es6-symbol/implement')
require('babel-polyfill')
import Vue from 'vue'
import App from './App'
import router from './router'
// import store from './store'
// import ElementUI from 'element'
import Echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/legendScroll'
import 'echarts/lib/component/dataZoom'
import * as Echarts5 from 'echarts5'

import 'whatwg-fetch'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/getorgchart.css'
import OrgChart from '../vendor/getorgchart'
import SnLayout from '@/components/common/portal/index'
import * as SNLoading from '@/components/loading/index'
import Page from '@/components/page/index'
import Tree from '@/components/tree/index'
import 'lib-flexible'
import VueClipboard from 'vue-clipboard2'
import './styles/theme/index.css'
// 图片预览插件
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

// 全局注册组件
Vue.use(preview)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

SNLoading.default.install(Vue)
Vue.use(Page)
Vue.use(Tree)

import SdRef from '@/components/controls/reference.vue'
Vue.component('sd-ref', SdRef)

// var vueResource = require('vue-resource')
// Vue.use(vueResource)

Vue.config.devtools = true
if (process.env.NODE_ENV === 'development') {
  window.prefix = ''
} else {
  window.prefix = '.'
}

// axios 整合
import axios from 'axios'
axios.defaults.withCredentials = true // true 跨域问题
Vue.prototype.$axios = axios

// OA生产环境
// window.oaWorkflowUri = 'http://xyoa.xiangyu.com/workflow/request/WorkflowRequestPicture.jsp?requestid='
// OA准生产环境
// window.oaWorkflowUri = 'http://10.16.128.31:8080/workflow/request/WorkflowRequestPicture.jsp?requestid='
if (process.env.CONST === 'build-prod') {
  window.oaWorkflowUri = 'http://xyoa.xiangyu.com/workflow/request/WorkflowRequestPicture.jsp?requestid='
} else {
  window.oaWorkflowUri = 'http://10.16.128.31:8080/workflow/request/WorkflowRequestPicture.jsp?requestid='
}
Vue.use(SnLayout)
// Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$echarts = Echarts
Vue.prototype.$echarts5 = Echarts5
Vue.prototype.$userInfo = {}
Vue.prototype.$bus = new Vue()

window.vue = Vue
window.OrgChart = OrgChart
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // store,
  template: '<App/>',
  components: { App },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js